import * as React from 'react';
import { Component } from 'react';
import propz from 'propz';
import { parse } from 'query-string';
import BPromise from 'bluebird';
import {
  ColumnDefinition,
  getFilters2,
  getOrder,
  getSearchFilter,
  getSearchOrder,
  getServerFieldSectionWhere,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE, LIMIT } from 'Src/consts/table';
import { Loader } from 'Src/components/Loader/Loader';
import { AppUser } from 'Src/views/App/App';
import './Houses.css';
import { GenericSummary } from 'Src/components/GenericSummary/GenericSummary';
import { Button } from 'Src/components/Button/Button';
import { History, Location } from 'history';
import { getColor } from 'Src/helpers/cell/cell';
import { SchoolHouse } from 'Src/models/house';
import {
  createHouse,
  deleteHouse,
  getAllHouses,
  getHouses,
  getHousesCount,
  updateHouse
} from 'Src/helpers/service/admin/houses';
import { HOUSE_TABS } from 'Src/consts/house';
import { HouseForm } from './HouseForm/HouseForm';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { HouseSummary } from 'Src/components/HouseSummary/HouseSummary';
import { createAwardType } from 'Src/helpers/service/admin/awardTypes';
import { getSchoolAwardTypes, AwardType } from 'Src/helpers/service/admin/awards';
import { GrantAwardModal } from 'Src/components/GrantAwardModal/GrantAwardModal';
import { ModuleUpsellModal } from 'Src/components/ModuleUpsellModal/ModuleUpsellModal';
import { isModuleActiveFresh } from 'Src/helpers/modules/moduleHelpers';
import { getSchoolStudentsCount } from 'Src/helpers/service/admin/students';
import { PeopleFilterChipSelect } from 'Src/views/GenericView/AdminView/Users/PeopleFilterChipSelect';
import { PeopleFilterChips } from 'Src/views/GenericView/AdminView/Users/PeopleFilterChips';

const PLACEHOLDER = '/dist/images/empty_pic_uploader_box.png';
const LOGO_SIZE = 40;

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Logo',
    field: 'pic',
    isSort: false,
    type: FILTER_TYPE.NONE,
    cell: (house: any, _unused: any, rowIndex: number) => (
      <td key={`logo-cell-${rowIndex}`} style={{ padding: '4px' }}>
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#fff'
          }}
        >
          <img
            src={house.pic || PLACEHOLDER}
            alt="House logo"
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain'
            }}
          />
        </div>
      </td>
    )
  },
  {
    text: 'Name',
    field: 'name',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['name']
  },
  {
    text: 'Description',
    field: 'description',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: ['description']
  },
  {
    text: 'Colours',
    field: 'colors',
    isSort: false,
    type: FILTER_TYPE.NONE,
    cell: getColor
  },
  {
    text: 'Student assignments',
    field: 'withoutStudents',
    isSort: false,
    type: FILTER_TYPE.CHECKBOX,
    accessor: ['withoutStudents']
  }
];

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

interface State {
  items: SchoolHouse[];
  currentPage: number;
  selectedItems: SchoolHouse[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  isSelectAllChecked: boolean;
  total: number;
  basePath: string;

  isEditHousePopupOpened: boolean;
  isDeleteHouseModalOpen: boolean;
  isDeleteHouseProhibitionModalOpen: boolean;
  deleteHouseConfirmationModalText: string;
  deleteHouseProhibitionModalText: string;
  housesWithoutStudents: SchoolHouse[];
  editingHouse: SchoolHouse | null;

  isGrantAwardOpen: boolean;
  preselectedAwardType: AwardType | null;
  isSelectionMenuOpen: boolean;
}

export class Houses extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isLoading: false,
      isSelectAllChecked: false,
      total: 0,
      basePath: '',

      isEditHousePopupOpened: false,
      isDeleteHouseModalOpen: false,
      isDeleteHouseProhibitionModalOpen: false,
      deleteHouseConfirmationModalText: '',
      deleteHouseProhibitionModalText: '',
      housesWithoutStudents: [],
      editingHouse: null,

      isGrantAwardOpen: false,
      preselectedAwardType: null,
      isSelectionMenuOpen: false
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    this.setItems();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true
      });
      this.setItems();
    }
  }

  getHousesWhere(filters): any {
    const filtersForServer = { ...filters };
    const withoutStudents = propz.get(filtersForServer, ['withoutStudents'], []);
    delete filtersForServer.withoutStudents;

    const where = getServerFieldSectionWhere(filtersForServer);
    if (Array.isArray(withoutStudents) && withoutStudents.indexOf('true') !== -1) {
      where.withoutStudents = true;
    }

    return where;
  }

  setItems() {
    const { history, user } = this.props;

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters2(COLUMNS, search);

    const isDataFiltered = isFilterExist2(filters);

    const where = this.getHousesWhere(filters);

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order);

    const getHousesPromise = getHouses(user, serverQueryFilter);
    const getHousesCountPromise = getHousesCount(user, where);

    return BPromise.all([getHousesCountPromise, getHousesPromise]).then(([countObj, houses]) => {
      const freshHousesById: { [key: string]: SchoolHouse } = houses.reduce(
        (result: { [key: string]: SchoolHouse }, house: SchoolHouse) => {
          result[house.id] = house;
          return result;
        },
        {}
      );
      const selectedItems = this.state.selectedItems.map(house => freshHousesById[house.id] || house);
      const editingHouse = this.state.editingHouse
        ? freshHousesById[this.state.editingHouse.id] || this.state.editingHouse
        : null;
      this.setState({
        currentPage: page,
        sortDirection: sortDirection,
        sortColumnsName: sortColumnsName,
        isShowFilter: false,
        isDataFiltered: isDataFiltered,
        filters: filters,
        items: houses,
        selectedItems,
        editingHouse,
        total: countObj.count,
        basePath: history.location.pathname,
        isLoading: false
      });

      return true;
    });
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search: string[] = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onItemClick = (index: number): void => {
    const { items } = this.state;
    const selectedHouse = items[index];

    this.setState({
      editingHouse: selectedHouse,
      isEditHousePopupOpened: false
    });
  };

  onItemSelect = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedHouse = items[index];

    const selectedHouseIndex = selectedItems.findIndex(house => selectedHouse.id === house.id);
    let selectedHousesUpdated = [...selectedItems];

    if (selectedHouseIndex !== -1) {
      selectedHousesUpdated.splice(selectedHouseIndex, 1);
    } else {
      selectedHousesUpdated.push(selectedHouse);
    }

    this.setState({
      selectedItems: selectedHousesUpdated,
      isSelectAllChecked: false
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const housesFiltered = items.filter(house => {
      return selectedItems.every(selectedHouse => selectedHouse.id !== house.id);
    });

    const selectedHouse = [...selectedItems, ...housesFiltered];

    this.setState({
      selectedItems: selectedHouse,
      isSelectAllChecked: true,
      isSelectionMenuOpen: false
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true
    });

    const user = this.props.user;

    const where = this.getHousesWhere(filters);

    getAllHouses(user, where).then(houses => {
      const housesFiltered = houses.filter(house => {
        return selectedItems.every(selectedHouse => selectedHouse.id !== house.id);
      });

      const selectedHouses = [...selectedItems, ...housesFiltered];

      this.setState({
        selectedItems: selectedHouses,
        isSelectAllChecked: true,
        isSelectionMenuOpen: false,
        isLoading: false
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isSelectionMenuOpen: false
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onClearFilterClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      filters: {},
      isShowFilter: false
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: ''
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    if (isShowFilter) {
      const search = parse(this.props.history.location.search);
      this.setState({
        isShowFilter: false,
        filters: getFilters2(COLUMNS, search)
      });
      return;
    }

    this.setState({
      isShowFilter: true
    });
  };

  onTabClick = (event, index: number) => {
    event.preventDefault();

    this.setState({
      total: index
    });
  };

  onEditHouseClick = event => {
    event.preventDefault();

    this.setState({ isEditHousePopupOpened: true });
  };

  getSummaryTabs(): React.ReactNode {
    const { selectedItems, items } = this.state;
    const selectedHouses = items.find(house => house.id === selectedItems[0].id);

    switch (true) {
      case selectedItems.length === 1:
        return <HouseSummary house={selectedHouses} />;
    }
  }

  renderHouseModal(): React.ReactNode {
    const { isEditHousePopupOpened, selectedItems } = this.state;
    const { user } = this.props;

    if (selectedItems.length === 0) {
      return (
        <SimpleModal
          isOpen={isEditHousePopupOpened}
          title="Create house"
          customClass="schoolStructure-modal schoolStructure-modal--form myHouseModal"
          onCloseClick={this.onCancelButtonClick}
          showFooter={false}
        >
          <HouseForm onCancel={this.onCancelButtonClick} onSubmit={this.onSaveButtonClick} user={user} />
        </SimpleModal>
      );
    } else {
      return (
        <SimpleModal
          isOpen={isEditHousePopupOpened}
          title="Edit house"
          customClass="schoolStructure-modal schoolStructure-modal--form myHouseModal"
          onCloseClick={this.onCancelButtonClick}
          showFooter={false}
        >
          <HouseForm
            house={selectedItems[0]}
            onCancel={this.onCancelButtonClick}
            onSubmit={this.onSaveButtonClick}
            user={user}
          />
        </SimpleModal>
      );
    }
  }

  onCreateHouseClick = () => {
    this.setState({
      isEditHousePopupOpened: true,
      editingHouse: null,
      selectedItems: []
    });
  };

  deleteHouseModalOpen = (): void => {
    const { selectedItems } = this.state;
    const { user } = this.props;

    if (selectedItems.length === 0) {
      return;
    }

    this.setState({ isLoading: true });

    BPromise.all(selectedItems.map(house => getSchoolStudentsCount(user, { houseId: house.id }))).then(counts => {
      const housesWithStudents: string[] = [];
      const housesWithoutStudents: SchoolHouse[] = [];

      counts.forEach((item, index) => {
        const house = selectedItems[index];
        item.count > 0 ? housesWithStudents.push(house.name) : housesWithoutStudents.push(house);
      });

      if (housesWithoutStudents.length === 0) {
        this.setState({
          isLoading: false,
          isDeleteHouseProhibitionModalOpen: true,
          deleteHouseProhibitionModalText: `The house(s) ${housesWithStudents.join(
            ', '
          )} cannot be deleted because students are linked to them. Move those students to another house first.`
        });
        return;
      }

      const blockedText =
        housesWithStudents.length > 0
          ? ` The house(s) ${housesWithStudents.join(', ')} cannot be deleted because students are linked to them.`
          : '';

      this.setState({
        isLoading: false,
        isDeleteHouseModalOpen: true,
        housesWithoutStudents,
        deleteHouseConfirmationModalText: `Delete ${
          housesWithoutStudents.length === 1
            ? `house ${housesWithoutStudents[0].name}`
            : `${housesWithoutStudents.length} houses`
        }?${blockedText}`
      });
    });
  };

  deleteHouseModalClose = (): void => {
    this.setState({
      isDeleteHouseModalOpen: false,
      isDeleteHouseProhibitionModalOpen: false
    });
  };

  onDeleteHouseClick = () => {
    const { housesWithoutStudents } = this.state;

    this.setState({ isLoading: true });
    const promises = housesWithoutStudents.map(house => {
      return deleteHouse(this.props.user, house.id);
    });
    BPromise.all(promises).then(() => {
      this.setState({
        selectedItems: [],
        housesWithoutStudents: [],
        isDeleteHouseModalOpen: false
      });
      this.setItems();
    });
  };
  onSaveButtonClick = (data): void => {
    const { user } = this.props;
    const { selectedItems, editingHouse } = this.state;

    this.setState({
      isLoading: true
    });

    if (editingHouse) {
      updateHouse(user, data, editingHouse.id).then(house => {
        this.setState({
          editingHouse: null
        });
        this.setItems();
      });
      return;
    }

    if (selectedItems.length === 0) {
      createHouse(this.props.user, data).then(house => {
        this.setState({
          isEditHousePopupOpened: false,
          selectedItems: [house]
        });
        this.setItems();
      });
    } else {
      const houseId = selectedItems[0].id;
      updateHouse(user, data, houseId).then(house => {
        this.setState({
          isEditHousePopupOpened: false,
          selectedItems: [house]
        });
        this.setItems();
      });
    }
  };

  onCancelButtonClick = (): void => {
    this.setState({
      isEditHousePopupOpened: false,
      editingHouse: null
    });
  };

  renderDeleteHouseModal() {
    const {
      isDeleteHouseModalOpen,
      isDeleteHouseProhibitionModalOpen,
      deleteHouseConfirmationModalText,
      deleteHouseProhibitionModalText
    } = this.state;

    return (
      <>
        <SimpleModal
          isOpen={isDeleteHouseModalOpen}
          title={'Delete house'}
          body={
            <div className="schoolStructure-warningModal schoolStructure-warningModal--danger">
              <div className="schoolStructure-warningModal__icon">!</div>
              <p>{deleteHouseConfirmationModalText}</p>
            </div>
          }
          buttonText={'Delete'}
          buttonCancelText="Cancel"
          onButtonClick={this.onDeleteHouseClick}
          onCloseClick={this.deleteHouseModalClose}
          customClass="schoolStructure-modal schoolStructure-modal--warning schoolStructure-modal--danger"
          dialogStyle={{ maxWidth: 480 }}
        />
        <SimpleModal
          isOpen={isDeleteHouseProhibitionModalOpen}
          title={'House is in use'}
          body={
            <div className="schoolStructure-warningModal">
              <div className="schoolStructure-warningModal__icon">!</div>
              <p>{deleteHouseProhibitionModalText}</p>
            </div>
          }
          onCloseClick={this.deleteHouseModalClose}
          customClass="schoolStructure-modal schoolStructure-modal--warning"
          buttonCancelText="Close"
          dialogStyle={{ maxWidth: 480 }}
        />
      </>
    );
  }
  private ensureHousePointsType = async (): Promise<AwardType> => {
    const { user } = this.props;

    const schoolPicRaw = user?.activeSchool?.pic as string | undefined;
    const picture = schoolPicRaw
      ? schoolPicRaw.startsWith('//')
        ? `${window.location.protocol}${schoolPicRaw}`
        : schoolPicRaw
      : undefined;

    const filter = {
      where: { name: 'House Points', isSystemHidden: true },
      limit: 1
    };

    const existing = await getSchoolAwardTypes(user, filter);
    if (existing && existing.length) return existing[0];

    const payload: any = {
      name: 'House Points',
      isSystemHidden: true,
      defaultHousePoints: 0
    };
    if (picture) payload.picture = picture;

    try {
      return await createAwardType(user, payload);
    } catch (err) {
      const e: any = err;
      const status = e?.response?.status;
      const text = e?.response?.data?.details?.text;

      if (status === 409 || text === 'duplicate error') {
        const retry = await getSchoolAwardTypes(user, filter);
        if (retry && retry.length) return retry[0];
      }

      throw err;
    }
  };

  private onGrantHousePoints = async () => {
    const { selectedItems } = this.state;
    const { user } = this.props;
    if (!selectedItems || selectedItems.length === 0) return;

    const awardsActive = await isModuleActiveFresh(user, 'AWARDS');
    if (!awardsActive) {
      this.setState({ isGrantAwardOpen: true });
      return;
    }

    this.setState({ isLoading: true });
    try {
      const awardType = await this.ensureHousePointsType();
      this.setState({
        isGrantAwardOpen: true,
        preselectedAwardType: awardType,
        isLoading: false
      });
    } catch (e) {
      console.error('Failed to ensure House Points award type', e);
      this.setState({ isLoading: false });
      alert('Unable to start house points grant right now.');
    }
  };

  onGrantHouseAwardClose = (result?: { granted?: boolean }): void => {
    this.setState(
      {
        isGrantAwardOpen: false,
        preselectedAwardType: null
      },
      () => {
        if (result && result.granted) {
          this.setItems();
        }
      }
    );
  };
  private renderGrantHouseAwardModal() {
    const { isGrantAwardOpen, preselectedAwardType, selectedItems } = this.state;
    const { user } = this.props;

    if (!isGrantAwardOpen) return null;

    // If no preselectedAwardType, module was inactive when button was clicked
    if (!preselectedAwardType) {
      return <ModuleUpsellModal isOpen={isGrantAwardOpen} onClose={this.onGrantHouseAwardClose} module="AWARDS" />;
    }

    return (
      <GrantAwardModal
        isOpen={isGrantAwardOpen}
        onClose={this.onGrantHouseAwardClose}
        user={user}
        houses={selectedItems}
        preselectedType={preselectedAwardType}
      />
    );
  }

  renderSummary() {
    const { selectedItems } = this.state;
    const isOneItemSelected = selectedItems.length === 1;

    if (!isOneItemSelected) {
      return <div className="font-weight-bold">Select a house above</div>;
    }

    const summaryTabs = this.getSummaryTabs();

    const isShowEditButton = selectedItems.length === 1;

    return (
      <GenericSummary onTabClick={this.onTabClick} tabs={HOUSE_TABS} currentTabIndex={0}>
        {isShowEditButton && <Button onClick={this.onEditHouseClick} text={'Edit'} customClass={'mt-3 mb-3'} />}
        {summaryTabs}
      </GenericSummary>
    );
  }

  onGrantEditingHousePoints = (): void => {
    const { editingHouse } = this.state;
    if (!editingHouse) {
      return;
    }
    this.setState({ selectedItems: [editingHouse] }, this.onGrantHousePoints);
  };

  onDeleteEditingHouseClick = (): void => {
    const { editingHouse } = this.state;
    if (!editingHouse) {
      return;
    }
    this.setState({ selectedItems: [editingHouse] }, this.deleteHouseModalOpen);
  };
  renderEditDrawer(): React.ReactNode {
    const { editingHouse } = this.state;
    const { user } = this.props;

    if (!editingHouse) {
      return null;
    }

    const [primary, secondary] = this.getHouseColors(editingHouse);
    const members = propz.get(editingHouse, ['members'], propz.get(editingHouse, ['studentsCount'], undefined));
    const points = propz.get(editingHouse, ['points'], propz.get(editingHouse, ['housePoints'], undefined));

    return (
      <>
        <div className="schoolStructure-drawerScrim" onClick={this.onCancelButtonClick} />
        <aside className="schoolStructure-drawer schoolStructure-drawer--house" role="dialog" aria-modal="true">
          <div className="schoolStructure-drawer__head schoolStructure-drawer__head--rich">
            {this.renderHouseCrest(editingHouse, 44)}
            <div>
              <div className="schoolStructure-drawer__eyebrow">House</div>
              <h2>{editingHouse.name}</h2>
              <p>
                {typeof members === 'number' ? `${members} members` : 'Members unavailable'} ·{' '}
                {typeof points === 'number' ? `${points.toLocaleString('en-GB')} points` : 'Points unavailable'}
              </p>
            </div>
            <button
              type="button"
              className="schoolStructure-drawer__close"
              onClick={this.onCancelButtonClick}
              aria-label="Close"
            >
              ×
            </button>
          </div>
          <div className="schoolStructure-drawer__body">
            <div className="schoolStructure-detailStats">
              <div className="schoolStructure-detailStat">
                <span>Children</span>
                <strong>{typeof members === 'number' ? members.toLocaleString('en-GB') : '-'}</strong>
              </div>
              <div className="schoolStructure-detailStat">
                <span>House points</span>
                <strong style={{ color: primary }}>
                  {typeof points === 'number' ? points.toLocaleString('en-GB') : '-'}
                </strong>
              </div>
            </div>
            <div className="schoolStructure-formPanel">
              <HouseForm
                key={editingHouse.id}
                house={editingHouse}
                onCancel={this.onCancelButtonClick}
                onSubmit={this.onSaveButtonClick}
                user={user}
              />
            </div>
          </div>
          <div className="schoolStructure-drawer__footer">
            <button
              type="button"
              className="schoolStructure-btn schoolStructure-btn--danger"
              onClick={this.onDeleteEditingHouseClick}
            >
              Delete
            </button>
            <button
              type="button"
              className="schoolStructure-btn schoolStructure-btn--secondary"
              onClick={this.onGrantEditingHousePoints}
            >
              Grant points
            </button>
            <button
              type="button"
              className="schoolStructure-btn schoolStructure-btn--primary"
              onClick={this.onCancelButtonClick}
            >
              Done
            </button>
          </div>
        </aside>
      </>
    );
  }
  onSearchChange = (event): void => {
    const filters = { ...this.state.filters, name: event.target.value };
    this.setState({ filters });
  };

  onSearchKeyDown = (event): void => {
    if (event.key === 'Enter') {
      this.onApplyFilterClick();
    }
  };

  onRemoveFilterChip = (field: string): void => {
    const filters = { ...this.state.filters };
    delete filters[field];
    this.setState({ filters }, this.onApplyFilterClick);
  };

  onWithoutStudentsFilterChange = (value: string): void => {
    const filters = { ...this.state.filters };
    const selected = Array.isArray(filters.withoutStudents) ? filters.withoutStudents : [];
    const withoutStudents =
      selected.indexOf(value) !== -1 ? selected.filter(item => item !== value) : [...selected, value];

    if (withoutStudents.length > 0) {
      filters.withoutStudents = withoutStudents;
    } else {
      delete filters.withoutStudents;
    }

    this.setState({ filters });
  };

  getHouseColors(house: SchoolHouse): string[] {
    const colors = propz.get(house, ['colors'], []);
    return Array.isArray(colors) && colors.length > 0 ? colors : ['#227ebd', '#7fb8e0'];
  }

  renderHouseCrest(house: SchoolHouse, size: number = 46): React.ReactNode {
    const [primary, secondary] = this.getHouseColors(house);
    const pic = propz.get(house, ['pic'], '');

    if (pic) {
      return (
        <img
          className="schoolStructure-houseCrest"
          style={{ width: size, height: size }}
          src={pic}
          alt={`${house.name} crest`}
        />
      );
    }

    return (
      <span
        className="schoolStructure-houseCrest schoolStructure-houseCrest--initial"
        style={{ width: size, height: size, background: `linear-gradient(135deg, ${primary}, ${secondary})` }}
      >
        {house.name ? house.name.charAt(0) : '?'}
      </span>
    );
  }

  renderColourDots(house: SchoolHouse): React.ReactNode {
    return (
      <span className="schoolStructure-colours">
        {this.getHouseColors(house).map((color, index) => (
          <i key={`${house.id}-colour-${index}`} style={{ background: color }} />
        ))}
      </span>
    );
  }

  renderToolbar(): React.ReactNode {
    const { filters, total, isShowFilter, isSelectionMenuOpen, items, selectedItems } = this.state;
    const searchValue = propz.get(filters, ['name'], '');
    const selectedWithoutStudents = propz.get(filters, ['withoutStudents'], []);
    const hasActiveFilters = isFilterExist2(filters);
    const selectedIds = new Set(selectedItems.map(item => item.id));
    const allPageSelected = items.length > 0 && items.every(item => selectedIds.has(item.id));

    return (
      <div className="schoolStructure-toolbar schoolStructure-toolbar--inlineFilters">
        <div className="schoolStructure-toolbar__titleControls">
          <div className="schoolStructure-toolbar__heading">
            <h2>Houses</h2>
            <span>{total}</span>
          </div>
          <label className="schoolStructure-search schoolStructure-search--compact">
            <input
              type="text"
              aria-label="Search houses"
              value={searchValue}
              placeholder="Search houses..."
              onChange={this.onSearchChange}
              onKeyDown={this.onSearchKeyDown}
            />
          </label>
          <button
            type="button"
            className={`schoolStructure-btn schoolStructure-btn--secondary schoolStructure-filterBtn${
              isShowFilter ? ' schoolStructure-btn--active' : ''
            }`}
            onClick={this.onTableFilterClick}
          >
            <span className="schoolStructure-buttonIcon schoolStructure-buttonIcon--filter" aria-hidden="true" />
            Filters
            {selectedWithoutStudents.length > 0 ? (
              <span className="schoolStructure-filterCount">{selectedWithoutStudents.length}</span>
            ) : null}
          </button>
          {hasActiveFilters ? (
            <button type="button" className="schoolStructure-clearFilters" onClick={this.onClearFilterClick}>
              Clear filters
            </button>
          ) : null}
          <div className="schoolStructure-selectMenu">
            <button
              type="button"
              className={`schoolStructure-btn schoolStructure-btn--secondary ${
                allPageSelected ? 'schoolStructure-btn--active' : ''
              }`}
              onClick={() => this.setState({ isSelectionMenuOpen: !isSelectionMenuOpen })}
            >
              Select
            </button>
            {isSelectionMenuOpen && (
              <div className="people-bulkSelect__menu schoolStructure-selectMenu__menu">
                <button type="button" onClick={this.onSelectAllOnPageClick}>
                  Select this page
                </button>
                <button type="button" onClick={this.onSelectAllClick}>
                  Select all
                </button>
                <button type="button" disabled={selectedItems.length === 0} onClick={this.onUnselectAllClick}>
                  Clear selection
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="schoolStructure-toolbar__controls">
          <button
            type="button"
            className="schoolStructure-btn schoolStructure-btn--primary"
            onClick={this.onCreateHouseClick}
          >
            <span aria-hidden="true">+</span>
            Create house
          </button>
        </div>
      </div>
    );
  }

  renderFilters(): React.ReactNode {
    const { filters, isShowFilter } = this.state;

    if (!isShowFilter) {
      return null;
    }

    const selectedWithoutStudents = propz.get(filters, ['withoutStudents'], []);

    return (
      <>
        <div className="schoolStructure-drawerScrim" onClick={this.onTableFilterClick} />
        <aside className="schoolStructure-drawer schoolStructure-drawer--filters" aria-label="House filters">
          <div className="schoolStructure-drawer__head">
            <div>
              <h2>Filters</h2>
            </div>
            <button
              type="button"
              className="schoolStructure-drawer__close"
              aria-label="Close filters"
              onClick={this.onTableFilterClick}
            >
              ×
            </button>
          </div>
          <div className="schoolStructure-drawer__body schoolStructure-filterSections">
            <PeopleFilterChipSelect
              label="Student assignments"
              options={[{ value: 'true', label: 'No students attached' }]}
              selected={selectedWithoutStudents}
              onToggle={this.onWithoutStudentsFilterChange}
            />
          </div>
          <div className="schoolStructure-drawer__footer schoolStructure-filterFooter">
            <button
              type="button"
              className="schoolStructure-btn schoolStructure-btn--secondary is-clear"
              onClick={this.onClearFilterClick}
            >
              Clear all
            </button>
            <div>
              <button
                type="button"
                className="schoolStructure-btn schoolStructure-btn--secondary"
                onClick={this.onTableFilterClick}
              >
                Cancel
              </button>
              <button
                type="button"
                className="schoolStructure-btn schoolStructure-btn--primary is-apply"
                onClick={this.onApplyFilterClick}
              >
                Apply
              </button>
            </div>
          </div>
        </aside>
      </>
    );
  }

  renderActiveFilters(): React.ReactNode {
    const filters = { ...this.state.filters };
    delete filters.name;

    return (
      <PeopleFilterChips
        filters={filters}
        columns={[{ field: 'withoutStudents', text: 'Student assignments' }]}
        valueLabels={{ withoutStudents: { true: 'No students attached' } }}
        onRemove={this.onRemoveFilterChip}
        onClear={this.onClearFilterClick}
      />
    );
  }

  renderSelectionBar(): React.ReactNode {
    const { selectedItems } = this.state;
    const selectedCount = selectedItems.length;

    if (selectedCount === 0) {
      return null;
    }

    return (
      <div className="schoolStructure-selection">
        <span className="schoolStructure-selection__summary">
          {selectedCount} {selectedCount === 1 ? 'house' : 'houses'} selected
        </span>
        <div className="schoolStructure-selection__actions">
          <button
            type="button"
            className="schoolStructure-btn schoolStructure-btn--secondary"
            onClick={this.onGrantHousePoints}
          >
            Grant house points
          </button>
          <button
            type="button"
            className="schoolStructure-btn schoolStructure-btn--danger"
            onClick={this.deleteHouseModalOpen}
          >
            Delete
          </button>
        </div>
        <div className="schoolStructure-toolbar__spacer" />
        <button type="button" className="schoolStructure-selection__clear" onClick={this.onUnselectAllClick}>
          Clear selection
        </button>
      </div>
    );
  }

  renderHouseCards(): React.ReactNode {
    const { items, selectedItems, editingHouse, currentPage, total } = this.state;
    const selectedIds = new Set(selectedItems.map(item => item.id));
    const pageCount = Math.max(1, Math.ceil(total / LIMIT));

    return (
      <>
        {items.length === 0 ? (
          <div className="schoolStructure-emptyCard">
            <div className="schoolStructure-emptyCard__icon" aria-hidden="true" />
            <h3>No houses</h3>
            <p>Create a house to start grouping pupils and running the House Race.</p>
          </div>
        ) : (
          <div className="schoolStructure-houseGrid">
            {items.map((house, index) => {
              const [primary, secondary] = this.getHouseColors(house);
              const isSelected = selectedIds.has(house.id);
              const isPreviewed = Boolean(editingHouse && editingHouse.id === house.id);
              const members = propz.get(house, ['members'], propz.get(house, ['studentsCount'], undefined));
              const points = propz.get(house, ['points'], propz.get(house, ['housePoints'], undefined));

              return (
                <article
                  key={house.id}
                  className="schoolStructure-houseCard"
                  data-selected={isSelected}
                  data-preview={isPreviewed}
                  onClick={() => this.onItemClick(index)}
                >
                  <div
                    className="schoolStructure-houseCard__stripe"
                    style={{ background: `linear-gradient(90deg, ${primary}, ${secondary})` }}
                  />
                  <div className="schoolStructure-houseCard__body">
                    <div className="schoolStructure-houseCard__top">
                      {this.renderHouseCrest(house)}
                      <div className="schoolStructure-houseCard__title">
                        <h3>{house.name}</h3>
                        {this.renderColourDots(house)}
                      </div>
                      <label className="schoolStructure-cardCheck" onClick={event => event.stopPropagation()}>
                        <input type="checkbox" checked={isSelected} onChange={() => this.onItemSelect(index)} />
                        <span />
                      </label>
                    </div>
                    <p>{house.description || 'No description yet.'}</p>
                    <div className="schoolStructure-houseCard__stats">
                      <div>
                        <strong>{typeof members === 'number' ? members : '-'}</strong>
                        <span>Members</span>
                      </div>
                      <div>
                        <strong style={{ color: primary }}>
                          {typeof points === 'number' ? points.toLocaleString('en-GB') : '-'}
                        </strong>
                        <span>House points</span>
                      </div>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        )}
        <div className="schoolStructure-pagination">
          <span className="schoolStructure-pagination__summary">
            Page {currentPage} of {pageCount}
          </span>
          <button
            type="button"
            className="schoolStructure-btn schoolStructure-btn--secondary"
            disabled={currentPage <= 1}
            onClick={() => this.setCurrentPageParams(currentPage - 1)}
          >
            Previous
          </button>
          <button
            type="button"
            className="schoolStructure-btn schoolStructure-btn--secondary"
            disabled={currentPage >= pageCount}
            onClick={() => this.setCurrentPageParams(currentPage + 1)}
          >
            Next
          </button>
        </div>
      </>
    );
  }
  render() {
    const { isLoading, isEditHousePopupOpened, editingHouse } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const classes = isEditHousePopupOpened || editingHouse ? 'mt-3 modal-open' : 'mt-3';

    return (
      <div className={classes}>
        {this.renderDeleteHouseModal()}
        {this.renderHouseModal()}
        {this.renderEditDrawer()}
        {this.renderGrantHouseAwardModal()}
        {this.renderFilters()}
        {this.renderToolbar()}
        {this.renderActiveFilters()}
        {this.renderSelectionBar()}
        {this.renderHouseCards()}
      </div>
    );
  }
}
